var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32,
    r: 32,
    fill: "#2768EA",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1666 38.0111L25.0444 33.9L26.611 32.3222L29.1666 34.8778L38.3777 25.6556L39.9444 27.2333L29.1666 38.0111Z",
    fill: "#2768EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 45.3333C29.8629 45.3333 27.2851 44.5513 25.0924 43.0862C22.8998 41.6211 21.1908 39.5388 20.1816 37.1024C19.1725 34.6661 18.9084 31.9852 19.4229 29.3988C19.9374 26.8124 21.2072 24.4366 23.0719 22.5719C24.9366 20.7072 27.3124 19.4373 29.8988 18.9228C32.4852 18.4084 35.1661 18.6724 37.6025 19.6816C40.0388 20.6907 42.1212 22.3997 43.5863 24.5924C45.0514 26.785 45.8334 29.3629 45.8334 32C45.8334 35.5362 44.4286 38.9276 41.9281 41.4281C39.4276 43.9285 36.0362 45.3333 32.5 45.3333ZM32.5 20.8889C30.3024 20.8889 28.1542 21.5405 26.327 22.7614C24.4998 23.9823 23.0757 25.7176 22.2347 27.7479C21.3937 29.7782 21.1737 32.0123 21.6024 34.1676C22.0311 36.323 23.0893 38.3028 24.6433 39.8567C26.1972 41.4106 28.177 42.4689 30.3324 42.8976C32.4877 43.3263 34.7218 43.1063 36.7521 42.2653C38.7824 41.4243 40.5177 40.0002 41.7386 38.173C42.9595 36.3458 43.6111 34.1975 43.6111 32C43.6111 29.0531 42.4405 26.227 40.3568 24.1432C38.273 22.0595 35.4469 20.8889 32.5 20.8889Z",
    fill: "#2768EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc);
export default __webpack_public_path__ + "static/media/ic.8c3733d150f2aa8291a60f9030aff5e0.svg";
export { ForwardRef as ReactComponent };